import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function UnbezahlteUeberstunden({
  onBlur,
  className,
}: {
  onBlur?: () => void;
  className?: string;
}) {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();
  return (
    <form.AppField
      name="bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenMonat"
      listeners={{
        onBlur: () => {
          onBlur?.();
        },
      }}>
      {(field) => (
        <field.HoursInput
          label={t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.description',
          )}
          className={className}
          suffix={t('general.date.hours')}
          placeholder="hh:mm"
        />
      )}
    </form.AppField>
  );
}
